import axios from 'axios';
import qs from "qs";

export const getPaymentMethods = async () => {
    try {
        const {data} = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/payment/methods`,
        );

        return data;
    } catch (e) {

    }
    return [];
};

export const postPaymentRequest = async (payload) => {
    try {
        const {data} = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/payment/create/donation`,
            payload,
            {
                headers: {'Content-Type': 'application/json', 'organization-code': 'LIMMUD_BALTICS'}
            }
        );

        return data;
    } catch (e) {

    }
    return [];
}

async function ajaxCall(request) {
    const reactAppData = window.limmud_donation || {}
    const {ajax_url} = reactAppData

    if (ajax_url) {
        try {
            const {data} = await axios.post(ajax_url, qs.stringify(request));

            return data;
        } catch (e) {
            console.log(e);
        }
    }
}
